// extracted by mini-css-extract-plugin
module.exports =  {"headline":"lqgCFC","totals":"uzbgvO","line":"VichYS","totalShippingRoot":"yJAMAa","divider":"sRIWuY","cartSummary":"Q0uCMB","deliveryValue":"K1M4qs","originalPrice":"yf_YAu"};